import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'

export function formatDate(dateStr) {
  if (!dateStr) return null

  const date = new Date(`${dateStr}T00:00:00`)
  try {
    const formattedDate = new Intl.DateTimeFormat(i18n.language, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date)
    return formattedDate
  } catch (e) {
    return null
  }
}

export const useFormatDateRange = (startDate, endDate) => {
  const { t } = useTranslation()

  const formattedDateRange = useMemo(() => {
    if (!startDate || !endDate) return undefined
    const formattedStart = formatDate(startDate)
    const formattedEnd = formatDate(endDate)
    return t('reports.custom-dates-with-range', { dateRange: `${formattedStart} - ${formattedEnd}` }, 'Custom Dates')
  }, [startDate, endDate, t])

  return formattedDateRange
}

export default function useChips({ selectedChipName, customDates = { startDate: null, endDate: null } }) {
  const { t } = useTranslation()
  const formattedDateRange = useFormatDateRange(customDates?.startDate, customDates?.endDate)

  const chips = useMemo(
    () => [
      {
        name: 'month',
        label: t('reports.chips.current-month', 'This Month'),
        selected: selectedChipName === 'currentMonth',
        value: 'currentMonth',
      },
      {
        name: 'year',
        label: t('reports.chips.current-year', 'This Year'),
        selected: selectedChipName === 'currentYear',
        value: 'currentYear',
      },
      {
        name: 'lastYear',
        label: t('reports.chips.last-year', 'Last Year'),
        selected: selectedChipName === 'lastYear',
        value: 'lastYear',
      },
      {
        name: 'custom',
        label: formattedDateRange || t('reports.chips.custom-dates', 'Custom Dates'),
        selected: selectedChipName === 'custom',
        value: 'custom',
      },
    ],
    [selectedChipName, formattedDateRange, t]
  )

  return { chips }
}
